import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles((theme) => ({
  root: {
     
      margin: 'auto',
    '& > *': {
      margin: theme.spacing(1),
    },
    width: '300px',
    [theme.breakpoints.down('sm')]: {
        width: '100%',
    },
  },
  btnGrp: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(1),
  },
}));

export default function FloatingActionButtons({handleClick}) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
        <div className={classes.btnGrp}>
      <div style={{flexGrow: 1}} className="text-center">
      <Fab color="primary" aria-label="add" size="large" onClick={(e) => handleClick('1')}>
       1
      </Fab>
      </div>
      <div style={{flexGrow: 1}} className="text-center">
      <Fab color="primary" aria-label="add" onClick={(e) => handleClick('2')}>
          2
      </Fab>
      </div>
      <div style={{flexGrow: 1}} className="text-center">
      <Fab color="primary" aria-label="add" onClick={(e) => handleClick('3')}>
       3
      </Fab>
      </div>
      </div>
      <div className={classes.btnGrp}>
      <div style={{flexGrow: 1}} className="text-center">
      <Fab color="primary" aria-label="add" onClick={(e) => handleClick('4')}>
       4
      </Fab>
      </div>
      <div style={{flexGrow: 1}} className="text-center">
      <Fab color="primary" aria-label="add" onClick={(e) => handleClick('5')}>
        5
      </Fab>
      </div>
      <div style={{flexGrow: 1}} className="text-center">
      <Fab color="primary" aria-label="add" onClick={(e) => handleClick('6')}>
       6
      </Fab>
      </div>
      </div>
      <div className={classes.btnGrp}>
      <div style={{flexGrow: 1}} className="text-center">
      <Fab color="primary" aria-label="add" onClick={(e) => handleClick('7')}>
      7
      </Fab>
      </div>
      <div style={{flexGrow: 1}} className="text-center">
      <Fab color="primary" aria-label="add" onClick={(e) => handleClick('8')}>
     8
      </Fab>
      </div>
      <div style={{flexGrow: 1}} className="text-center">
      <Fab color="primary" aria-label="add" onClick={(e) => handleClick('9')}>
      9
      </Fab>
      </div>
      </div>
      <div className={classes.btnGrp}>
      <div style={{flexGrow: 1}} className="text-center" className="invi">
      <Fab color="primary" aria-label="add" onClick={(e) => handleClick('a')}>
        <AddIcon />
      </Fab>
      </div>
      <div style={{flexGrow: 1}} className="text-center">
      <Fab color="primary" aria-label="add" onClick={(e) => handleClick('0')}>
      0
      </Fab>
      
      </div>
      <div style={{flexGrow: 1}} className="text-center">
      <Fab color="primary" aria-label="add" onClick={(e) => handleClick('x')}>
            <CloseIcon/>
      </Fab>
      
      </div>
      </div>
    </div>
  );
}
